import { useRef } from 'react'

class TableStore {
  hooked = false

  constructor() {
    this.hooked = true
  }

  getInstance = () => ({
    hooked: this.hooked,
  })
}

const useTable = (comp, methods = {}) => {
  const ref = useRef()

  if (!ref.current) {
    if (comp) {
      ref.current = comp
    } else {
      const table_store = new TableStore()
      ref.current = table_store.getInstance()
    }
  }

  Object.entries(methods).forEach(([k, v]) => {
    ref.current[k] = v
  })

  return [ref.current]
}

export default useTable
